import React from 'react'
import {Col, Form, FormGroup, Row} from "reactstrap";
import FieldWithValidation from "../../generic/fields/FieldWithValidation";
import {Controller} from "react-hook-form";
import {t} from "i18next";

const EditModalChildren = ({entity, setEntity, control, errors, handleInput}) => {
    return <Form>
        <Row>
            <Col lg={6}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="name"
                        defaultValue={entity.name || ''}
                        rules={{required: t('inputs.validation.required')}}
                        render={(
                            {value, onBlur, name, ref, onChange},
                            {invalid}
                        ) =>
                            <FieldWithValidation invalid={invalid} errors={errors} name={name} isRequired={true}
                                                 type="text" onBlur={onBlur} value={value}
                                                 label={t('directories.eventCategory.name')}
                                                 placeholder={t('directories.eventCategory.name')}
                                                 onChange={e => {onChange(handleInput(e, setEntity).value)}}
                            />
                        }
                    />
                </FormGroup>
            </Col>
            <Col lg={6}>
                <FormGroup>
                    <Controller
                        control={control}
                        name="key"
                        defaultValue={entity.key}
                        render={(
                            {value, onBlur, name}
                        ) =>
                            <FieldWithValidation errors={errors} name={name}
                                                 label={t('directories.eventCategory.key')} disabled
                                                 type="text" onBlur={onBlur} value={value}
                                                 placeholder={t('directories.eventCategory.key')}
                                                 info={t('directories.eventCategory.infoIcon.keyInputInfo')}
                                                 container={'.modal'}
                            />
                        }
                    />
                </FormGroup>
            </Col>
        </Row>
    </Form>
}

export default EditModalChildren;
